<script lang="ts">
  import clsx from 'clsx';
  import { setContext } from 'svelte';
  import {
    unorderedListContextKey,
    type UnorderedListContext,
    type UnorderedListProps,
  } from './types';

  const { children, class: className }: UnorderedListProps = $props();
  const context: UnorderedListContext = {
    renderedItems: 0,
  };
  setContext(unorderedListContextKey, context);
</script>

<ul class={clsx(className, '')}>
  {@render children()}
</ul>
